export const ParticalStyle = () => {
  return (
    <div className="wrap">
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
      <div className="c" />
    </div>
  );
};
